import React from "react";
import SoeskenSammeFar from "./SoeskenSammeFar";
import SoeskenSammeMor from "./SoeskenSammeMor";
import SoeskenSammeKull from "./SoeskenSammeKull";
import HelSoesken from "./HelSoesken";


const Soesken = (props) => {
    const {kull, helSoeskenValper, kullSammeMor, kullSammeFar} = props;


    return (

        <div>
            {
                kull !== null &&
                <SoeskenSammeKull kull={kull}/>
            }
            {
                kull !== null && helSoeskenValper !== null &&
                <HelSoesken valper={helSoeskenValper} far={kull.far} mor={kull.mor} />
            }

            <SoeskenSammeFar kullSammeFar={kullSammeFar}/>
            <SoeskenSammeMor kullSammeMor={kullSammeMor}/>


        </div>
    );
};

export default Soesken;